import * as yup from "yup";

// UAE mobile: local 05XXXXXXXX (10 digits) or international 971XXXXXXXXX (12 digits)
export const UAE_MOBILE_REGEX = /^(971[0-9]{9}|05[0-9]{8})$/;
export const UAE_MOBILE_MESSAGE = "Mobile number must be in UAE format (e.g. 0501234567 or 971501234567)";

export const mobileNoRequired = () =>
  yup.string()
    .required("Mobile number is required")
    .matches(UAE_MOBILE_REGEX, UAE_MOBILE_MESSAGE);

export const mobileNoOptional = () =>
  yup.string()
    .matches(UAE_MOBILE_REGEX, UAE_MOBILE_MESSAGE)
    .nullable()
    .transform((v) => (v === "" ? null : v));
